import "./Services.css";
const Services = () => {
 return (
  <section className="services">
   <div className="container max-width">
    <p className="main-title" style={{ textAlign: "center" }}>
     Our Services
    </p>

    <h2 className="title " style={{ color: "rgb(1, 1, 34)" }}>
     What do you need?
    </h2>

    <div className="contents">
     <div className="content">
      <i className="fa fa-phone fa-3x" aria-hidden="true"></i>
      <br />
      <p className="sub-title">Hello World</p>
      <p>
       Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odit tenetur
       doloremque cumque a, quis fugit quaerat sequi minus provident esse?
      </p>
     </div>

     <div className="content">
      <i className="fa fa-phone fa-3x" aria-hidden="true"></i>
      <br />
      <p className="sub-title">Hello World</p>
      <p>
       Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odit tenetur
       doloremque cumque a, quis fugit quaerat sequi minus provident esse?
      </p>
     </div>

     <div className="content">
      <i className="fa fa-phone fa-3x" aria-hidden="true"></i>
      <br />
      <p className="sub-title">Hello World</p>
      <p>
       Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odit tenetur
       doloremque cumque a, quis fugit quaerat sequi minus provident esse?
      </p>
     </div>

     <div className="content">
      <i className="fa fa-phone fa-3x" aria-hidden="true"></i>
      <br />
      <p className="sub-title">Hello World</p>
      <p>
       Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odit tenetur
       doloremque cumque a, quis fugit quaerat sequi minus provident esse?
      </p>
     </div>

     <div className="content">
      <i className="fa fa-phone fa-3x" aria-hidden="true"></i>
      <br />
      <p className="sub-title">Hello World</p>
      <p>
       Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odit tenetur
       doloremque cumque a, quis fugit quaerat sequi minus provident esse?
      </p>
     </div>

     <div className="content">
      <i className="fa fa-phone fa-3x" aria-hidden="true"></i>
      <br />
      <p className="sub-title">Hello World</p>
      <p>
       Lorem ipsum dolor sit amet, consectetur adipisicing elit. Odit tenetur
       doloremque cumque a, quis fugit quaerat sequi minus provident esse?
      </p>
     </div>
    </div>
   </div>
  </section>
 );
};

export default Services;
